import { getSubMenus } from 'application/header/navbar/redux/actions';
import { ApplicationState } from 'application/redux';
import { connect } from 'react-redux';
import TabComponent from './tab-component';

const mapStateToProps = (state: ApplicationState) => ({
  navbar: state.navbar.navbar
});

export default connect(mapStateToProps, { getSubMenus })(TabComponent);
